export default __webpack_public_path__ + "static/media/about2.8e2d28ce.jpg";